import { quickNews } from "@/mocks/gossip";

export default function QuickNews() {
  const doubled = [...quickNews, ...quickNews];
  return (
    <div className="border-y border-background-200 bg-background-100">
      <div className="mx-auto flex max-w-[1240px] items-center gap-3 px-4 py-2.5 md:px-6">
        <span className="flex shrink-0 items-center gap-1.5 whitespace-nowrap text-xs font-semibold text-primary-700">
          <span className="flex h-5 w-5 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-flashlight-line text-[10px]"></i>
          </span>
          瓜田快讯
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="ticker-track flex w-max items-center gap-10 whitespace-nowrap">
            {doubled.map((n, i) => (
              <a key={i} href="#feed" className="flex items-center gap-2 text-sm text-foreground-700 hover:text-primary-700">
                <i className="ri-arrow-right-s-line text-accent-500"></i>
                {n}
                <span className="ml-6 text-foreground-300">/</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}